// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"64":"ec5d2fea772c80c5","8374":"576b9ec015ca4867","9487":"c20db38aed2676a5","9629":"bc398a494afcad14"}[chunkId] + ".css";
};